import * as types from './types';

export const setI18n = (i18nInstance) => ({
  type: types.SET_I18N,
  payload: i18nInstance
});

export const setIsBillingLive = (isLive) => ({
  type: types.SET_IS_BILLING_LIVE,
  payload: isLive
});

export const setIsAppLoading = (isLoading) => ({
  type: types.SET_IS_APP_LOADING,
  payload: isLoading
});

export const setSnackMessage = (message) => ({
  type: types.SET_SNACK_MESSAGE,
  payload: message
});

export const clearSnackMessage = () => ({
  type: types.CLEAR_SNACK_MESSAGE
});

export const setIsDemoMode = (isDemoMode) => ({
  type: types.SET_IS_DEMO_MODE,
  payload: isDemoMode
});

export const setLoadingModule = (moduleOrLoadingState, isLoading) => {
  if (typeof moduleOrLoadingState === 'object') {
    return {
      type: types.SET_LOADING_MODULE,
      payload: moduleOrLoadingState
    };
  }
  
  return {
    type: types.SET_LOADING_MODULE,
    payload: {
      [moduleOrLoadingState]: isLoading
    }
  };
};

// setAuthStateLoading has been moved to auth slice
// Re-export from auth actions for backward compatibility
export { setAuthLoading as setAuthStateLoading } from '../auth/actions';
